<template>
  <div class="admin-container">
      <div class="admin-content-container">
          <template>
              <!-- 按钮行 -->
              <div class="bar-row">
                <div class="left">
                      <el-button
                          @click="toogleMultiSelect('download')"
                          :disabled=" (chooseable && !!multiChoose.mode) || !hasPermission('download')"
                          icon="el-icon-download"
                          class="wl-green"
                      >
                          {{ $t('BATCH_DOWNLOAD') }}
                      </el-button>
                      
                  </div>
                  
                  <div class="wl-search-bar">
                    <div class="mr-15 invoice-tip">{{ $t('admin.invoiceTip1') }}<br>{{ $t('admin.invoiceTip2') }}</div>
                    <el-button @click="exportList('invoice')" class="wl-green svg-btn" :disabled="!hasPermission('download')">
                          <img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" />
                          {{ $t('Export_invoice_Items') }}
                      </el-button>
                    <el-button v-if="!isNOT_LLP" @click="exportList('fapiao')" class="wl-green svg-btn" :disabled="!hasPermission('download')">
                          <img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" />
                          {{ $t('Export_fapiao_Items') }}
                      </el-button>
                      
                      
                  </div>
              </div>
              <!-- 表格 -------------------------------start---------------->
              <div  :class="['table-container-wrapper', chooseable ? 'show-table-bottom-operate' : '']">
                  <el-table
                      height="100%"
                      v-loading="loading"
                      :data="data"
                      @select-all="(e) => handleSelectAll(e, list.data)"
                      @select="handleSelect"
                      border
                      ref="exchangeTable"
                      class="wl-table"
                      stripe
                  >
                      <!-- 筛选框 -->
                      <el-table-column v-if="chooseable"  type="selection" width="50">
                          
                      </el-table-column>
                      <!-- 实体名称en -->
                      <el-table-column prop="entityNameEn" width="200" :key="1" show-overflow-tooltip :label="$t('admin.entityNameEn')">
                        <template slot="header" slot-scope="scope">
                            <div class="table-header">
                                <div class="header-with-popup">
                                {{ $t('admin.entityNameEn') }}
                                <InputPopover
                                      :value.sync="searchForm.entityNameEn"
                                      :hidePopperSearch="hidePopperSearch"
                                  ></InputPopover>
                                </div>
                            </div>
                        </template>
                      </el-table-column>
                       <!-- 实体名称cn -->
                       <el-table-column prop="entityNameCn" width="200" :key="2" show-overflow-tooltip :label="$t('admin.entityNameCn')">
                        <template slot="header" slot-scope="scope">
                            <div class="table-header">
                                <div class="header-with-popup">
                                {{ $t('admin.entityNameCn') }}
                                <InputPopover
                                      :value.sync="searchForm.entityNameCn"
                                      :hidePopperSearch="hidePopperSearch"
                                  ></InputPopover>
                                </div>
                            </div>
                        </template>
                      </el-table-column>
                       <!-- 发行日期 -->
                       <el-table-column prop="issuanceDate" width="130" :key="3" show-overflow-tooltip :label="$t('admin.issuanceDate')">
                        <template slot="header" slot-scope="scope">
                            <div class="table-header">
                                <div class="header-with-popup">
                                {{ $t('admin.issuanceDate') }}
                                <DatePickerPopover
                                      :value.sync="searchForm.issuanceDateRange"
                                      :hidePopperSearch="hidePopperSearch"
                                  ></DatePickerPopover>
                                </div>
                            </div>
                        </template>
                        <template slot-scope="scope">
                              <span>{{ scope.row.issuanceDate | formatDate }}</span>
                          </template>
                      </el-table-column>
                       <!-- 不含税价 -->
                       <el-table-column prop="feeAmount" width="120" :key="4" show-overflow-tooltip :label="$t('admin.feeAmount')" align="right">
                        <template slot="header" slot-scope="scope">
                            <div class="table-header">
                                <div class="header-with-popup header-with-mount">
                                {{ $t('admin.feeAmount') }}
                                <el-popover
                                    placement="bottom"
                                    trigger="click"
                                    @hide="hidePopperSearch">
                                    <div class="th-filter-down" slot="reference">
                                        <slot name="icon">
                                            <i :class="['el-icon-arrow-down', searchForm.feeAmountRange&&searchForm.feeAmountRange.length>0 ? 'el-icon-arrow-down-active' : '']"></i>
                                        </slot>
                                    </div>
                                    <input-number-range v-model="searchForm.feeAmountRange" class="input-amount-container" :precision="2"/>
                                </el-popover>
                                </div>
                            </div>
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.feeAmount | formatNumThousandths }}
                        </template>
                      </el-table-column>
                       <!-- 含税总价  -->
                       <el-table-column prop="totalAmount" width="140" :key="5" show-overflow-tooltip :label="$t('admin.totalAmount')" align="right">
                        <template slot="header" slot-scope="scope">
                            <div class="table-header">
                                <div class="header-with-popup header-with-mount">
                                {{ $t('admin.totalAmount') }}
                                <el-popover
                                    placement="bottom"
                                    trigger="click"
                                    @hide="hidePopperSearch">
                                    <div class="th-filter-down" slot="reference">
                                        <slot name="icon">
                                            <i :class="['el-icon-arrow-down', searchForm.totalAmountRange&&searchForm.totalAmountRange.length>0 ? 'el-icon-arrow-down-active' : '']"></i>
                                        </slot>
                                    </div>
                                    <input-number-range v-model="searchForm.totalAmountRange" class="input-amount-container" :precision="2"/>
                                </el-popover>
                                </div>
                            </div> 
                        </template>
                        <template slot-scope="scope">
                            {{ scope.row.totalAmount | formatNumThousandths }}
                        </template>
                      </el-table-column>
                      <!-- 发票币种-->
                      <el-table-column prop="invoiceCurrency" width="130" :key="6" show-overflow-tooltip :label="$t('admin.invoiceCurrency')">
                        <template slot="header" slot-scope="scope">
                            <div class="table-header">
                                <div class="header-with-popup">
                                {{ $t('admin.invoiceCurrency') }}
                                </div>
                            </div>
                        </template>
                      </el-table-column>
                      <!-- 发票号 -->
                      <el-table-column prop="invoiceNumber" width="140" :key="7" show-overflow-tooltip :label="$t('admin.invoiceNumber')">
                        <template slot="header" slot-scope="scope">
                            <div class="table-header">
                                <div class="header-with-popup">
                                {{ $t('admin.invoiceNumber') }}
                                <InputPopover
                                      :value.sync="searchForm.invoiceNumber"
                                      :hidePopperSearch="hidePopperSearch"
                                  ></InputPopover>
                                </div>
                            </div>
                        </template>
                      </el-table-column>
                      <!-- 发票联系邮箱 -->
                      <el-table-column prop="invoiceContactEmail" width="200" :key="8" show-overflow-tooltip :label="$t('admin.invoiceContactEmail')">
                        <template slot="header" slot-scope="scope">
                            <div class="table-header">
                                <div class="header-with-popup">
                                {{ $t('admin.invoiceContactEmail') }}
                                <InputPopover
                                      :value.sync="searchForm.invoiceContactEmail"
                                      :hidePopperSearch="hidePopperSearch"
                                  ></InputPopover>
                                </div>
                            </div>
                        </template>
                      </el-table-column>
                     
                      <!-- 付清时间 -->
                      <el-table-column prop="settlementDate" width="140" :key="11" show-overflow-tooltip :label="$t('admin.settlementDate')">
                          <template slot="header">
                              <div class="header-with-popup">
                                  {{ $t('admin.settlementDate') }}
                                  <DatePickerPopover
                                      :value.sync="searchForm.settlementDateRange"
                                      :hidePopperSearch="hidePopperSearch"
                                  ></DatePickerPopover>
                              </div>
                          </template>
                          <template slot-scope="scope">
                              <span>{{ scope.row.settlementDate | formatDate }}</span>
                          </template>
                      </el-table-column>
                      <!-- 状态 -->
                      <el-table-column :key="12" prop="status" width="160"  :label="$t('admin.status')" fixed="right">
                        <template #header>
                              <div class="header-with-popup">
                                  {{ $t('admin.status') }}
                                  <MultiSelectPopver
                                      :hidePopperSearch="hidePopperSearch"
                                      :value.sync="searchForm.statusList"
                                      labelKey="label"
                                      valueKey="value"
                                      :inputFilterKey="['label', 'value']"
                                      :options="categoryOptions"
                                  ></MultiSelectPopver>
                              </div>
                          </template>
                          <template slot-scope="scope">
                            <div class="flex  item-center">
                                <svg-icon :icon-name='renderStatusIcon(scope.row.status)' :icon-color="renderStatusColor(scope.row.status)" :size="20" class="mr-10"></svg-icon>
                                <span :style="{color:renderStatusColor(scope.row.status)}">{{$t(`admin.${scope.row.status}`)}}</span>
                            </div>
                          </template>
                    </el-table-column>
                      <!-- 逾期时间 -->
                      <el-table-column :key="13" prop="overdueDays" width="200"  :label="$t('admin.overdueDays')" fixed="right" align="center">
                        <template #header>
                              <div class="header-with-popup">
                                  {{ $t('admin.overdueDays') }}
                                  <el-popover
                                    placement="bottom"
                                    trigger="click"
                                    @hide="filterOverdueDays">
                                    <div class="th-filter-down" slot="reference">
                                        <slot name="icon">
                                            <i :class="['el-icon-arrow-down', searchForm.startOverdueDays||searchForm.endOverdueDays ? 'el-icon-arrow-down-active' : '']"></i>
                                        </slot>
                                    </div>
                                    <el-input
                                        class="input-with-select"
                                        v-model="searchForm.startOverdueDays"
                                        size="medium"
                                        :placeholder="$t('minimum')"
                                        clearable
                                    ></el-input>
                                    <span>~</span>
                                    <el-input
                                        class="input-with-select"
                                        v-model="searchForm.endOverdueDays"
                                        size="medium"
                                        :placeholder="$t('maximum')"
                                        clearable
                                    ></el-input>
                                </el-popover>
                              </div>
                          </template>
                        <template slot-scope="scope">
                            <span class="overdue-days" :style="overdueDaysStyle(scope.row.status)">
                                <span v-if="scope.row.overdueDays==='NA'">{{ $t('admin.NA') }}</span>
                                <span v-else> {{scope.row.status === 'FULLY PAID' ?$t('admin.overdueDaysFullDes',{t:scope.row.overdueDays}): $t('admin.overdueDaysDes',{t:scope.row.overdueDays})}}</span>
                            </span>
                          </template>
                    </el-table-column>
                     <!-- 费用说明 -->
                     <el-table-column :key="9" prop="fileList" width="120"  :label="$t('admin.feeNote')"  fixed="right" class-name="file-name-cell">
                          <template slot-scope="scope">
                            <template v-if="scope.row.fileList && scope.row.fileList.length > 0">
                                <el-tooltip  effect="dark" :content="scope.row.fileList[0].name" placement="top-start" v-if="calcDisableDownload(scope.row.fileList[0])">
                                    <span>Bill.pdf</span>
                                </el-tooltip>
                                <span v-else class="file-name can-download">
                                    <el-tooltip  effect="dark" :content="$t('preview')" placement="top-start" >
                                        <span class="icon-preview" @click="previewPdf(scope.row)"><i class="el-icon-view" /></span>
                                    </el-tooltip>
                                    <el-tooltip  effect="dark" :content="scope.row.fileList[0].name" placement="top-start" >
                                        <span @click="downloadFeeNote(scope.row)">
                                        <i class="el-icon-download" />
                                        Bill.pdf
                                    </span>
                                    </el-tooltip>
                                </span>
                            </template>
                          </template>
                      </el-table-column>
                     <!-- 发票 -->
                      <el-table-column v-if="!isNOT_LLP" :key="10" prop="fapiao" width="100"  :label="$t('admin.fapiao')" show-overflow-tooltip fixed="right" header-align="center">
                          <template slot-scope="scope">
                            <div class="fapiao-col">
                                <span v-if="scope.row.fapiaoQuantity" class="fee-note" @click="toggleFaPiaoDetail(scope.row)">{{ scope.row.fapiaoQuantity }}</span>
                                <el-tooltip v-if="scope.row.invoiceFlag" effect="dark" :content="$t('admin.fapiaoTips')" placement="top-start" >
                                    <svg-icon icon-name="information" icon-color="#fd349c" :size="20" class="mr-10"></svg-icon>
                                </el-tooltip>
                            </div>
                          </template>
                      </el-table-column>
                      <!-- 留言 -->
                      <el-table-column width="100"  :label="$t('TABLE_HEAD_COMMENTS')" :key="14" fixed="right">
                            <template #header>
                                <div class="header-with-popup header-one-center">
                                    {{ $t('TABLE_HEAD_COMMENTS') }}
                                    <DatePickerPopover
                                        :value.sync="searchForm.commentDate"
                                        :hidePopperSearch="hidePopperSearch"
                                    ></DatePickerPopover>
                                </div>
                            </template>
                          <template slot-scope="scope">
                            <div class="flex  item-center justify-center">
                                <i
                                  :class="[
                                      scope.row.todayCommentCount > 0 ? 'wl-icon-messageBoard' : 'wl-icon-messageBoardNull',
                                      'el-icon-s-comment'
                                  ]"
                                  @click="toogleMessageBoardVisible(scope.row)"
                              ></i>
                              <span v-if="scope.row.todayCommentCount"> 
                                    <span class="message-today">{{ scope.row.todayCommentCount }}</span>
                                    <span>/</span> 
                              </span>
                              <span v-if="scope.row.messageNum > 0"> {{ scope.row.messageNum }}</span>
                            </div>
                          </template>
                      </el-table-column>
                  </el-table>
              </div>
              <div class="footer-btn" v-if="chooseable">
                  <el-button class="cancel-btn" @click="cancelChoose" :disabled="!chooseable">
                      {{ $t('btn_cancel') }}
                  </el-button>
                  <el-button
                      @click="downloadConfirm"
                      :disabled="chooseable && hasSelectedList.length == 0"
                      class="wl-green"
                      v-if="chooseable && multiChoose.mode == 'download'"
                  >
                      {{ $t('COMMON_DOWNLOAD') }}
                  </el-button>
              </div>
              <!------------------表格------------------------end-------------->
              <!-- 分页 -->
              <el-pagination
                  class="wl-pagination"
                  :current-page="pagination.pageNum"
                  :page-size="pagination.pageSize"
                  @current-change="onCurrentPageChange"
                  @size-change="onSizeChange"
                  layout="prev, pager, next, slot, total"
                  :total="pagination.total"
              >
                  <span>
                      <el-select v-model="pagination.pageSize" @change="onSizeChange">
                          <el-option v-for="item in pageOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                      </el-select>
                  </span>
              </el-pagination>
          </template>
      </div>
       <!--        文件详情-->
       <file-detail
          v-if="fileDetailVisbile"
          :id="rowData.id"
          :tableData="rowData.fileList"
          :curUserName="curUserName"
          activeTab="invoices"
          :downloadAble="downloadAble"
          :onCancel="toogleFileDetailVisible"
          @on-file-download="downloadFileDetail"
      />
    <!--        下载确认-->
    <file-confirm-modal
          :fileDownloading="fileDownloading"
          ref="FileConfirmModal"
          :groupList="hasSelectedList"
          @ok="downloadMultipleFiles"
          @on-file-download="downloadFileDetail"
          @updateMultipleSelection="updateMultipleSelection"
          :curUserName="curUserName"
          :downloadAble="downloadAble"
          :mode="downloadDialogMode"
          type="adminInvoice"
      />
      <file-confirm-fapiao-modal v-if="fapiaoBatchVisible" :groupList="hasSelectedList" :type="fileSelectionType"
          @ok="downloadMultipleFiles"
          @close="()=> fapiaoBatchVisible =!fapiaoBatchVisible"
          @on-file-download="downloadFileDetail"
          @updateMultipleSelection="updateMultipleSelection"
          :curUserName="curUserName"
          :downloadAble="downloadAble"
          :mode="downloadDialogMode"></file-confirm-fapiao-modal>

      <file-export-selection v-if="fileSelectionVisible" :onCancel="cancelBatchExport" :onConfirm="saveSelectionType"></file-export-selection>
      <!--        留言-->
      <messageBoard v-if="messageBoardVisible" :initData="rowData" :onCancel="toogleMessageBoardVisible" :onAdd="getTableList" messageType="6"/>
      <!-- 关联发票列表 -->
      <fapiao-detail
          v-if="fapiaoDetailVisible"
          :id="rowData.id"
          :row="rowData"
          :curUserName="curUserName"
          :downloadAble="downloadAble"
          :onCancel="() => this.fapiaoDetailVisible = !this.fapiaoDetailVisible"
          @on-file-download="downloadFileDetail"
      />
  </div>
</template>

<script>
import AdminAdd from './components/AdminAdd'
import upload from './components/upload'
import { mapGetters } from 'vuex'
import messageBoard from './components/messageBoard'
import fileDetail from './components/file-detail'
import API from '@/api'
import { formatFileSize, isIE, loading, dateFormat } from '@/utils'
import FileConfirmModal from './components/file-confirm-modal'
import { userPermission } from '@/mixins/userPermission.js'
import batchSelectTableMixins from '@/mixins/batchSelectTableMixins.js'
import windowConfig from '@/utils/windowConfig'
import MultiSelectPopver from '@/components/common/MultiSelectPopver.vue'
import { downloadSingleFile, downloadBatchFiles } from '@/utils/useDownload'
import UpdateEntityName from './components/UpdateEntityName'
import DatePickerPopover from '@/components/common/DatePickerPopover.vue'
import InputPopover from '@/components/common/InputPopover.vue'
import SvgIcon from '@/components/svgIcon/index'
import InputNumberRange from '@/components/common/InputNumberRange'
import FapiaoDetail from './components/fapiao-detail.vue'
import FileExportSelection from './components/file-export-selection.vue'
import FileConfirmFapiaoModal from './components/file-confirm-fapiao-modal.vue'

export default {
  name: 'InvoicesManagement',
  props:{
    clearFilterActive:Boolean
  },
  components: {
      UpdateEntityName,
      AdminAdd,
      upload,
      messageBoard,
      fileDetail,
      FileConfirmModal,
      MultiSelectPopver,
      DatePickerPopover,
      InputPopover,
      SvgIcon,
      InputNumberRange,
      FapiaoDetail,
      FileExportSelection,
      FileConfirmFapiaoModal,
  },
  computed: {
      ...mapGetters('common', {
          getUser: 'getUser',
          getSite: 'getSite',
          getEntityIds: 'getEntityIds'
      }),
      isKpmgUser() {
          return this.getUser.userType === '1'
      },
      categoryOptions(){
        return this.invoiceStatusOpt.map(item=>({
            label:this.$t(`admin.${item.value}`),
            value:item.value
        }))
      },
      isNOT_LLP(){
        return sessionStorage.getItem('siteFlag') === '0'
      }
     
  },
  mixins: [userPermission, batchSelectTableMixins],
  data() {
      return {
          updateEntityOption:{
              show:false,
              value:'',
              type:''
          },
          pageOptions: [
              { label: '10/' + this.$t('page') + this.$t('page_tip'), value: 10 },
              { label: '50/' + this.$t('page'), value: 50 },
              { label: '100/' + this.$t('page'), value: 100 }
          ],
          searchForm: {
              entityNameEn:'',
              entityNameCn:'',
              feeAmountRange:[],
              totalAmountRange:[],
              invoiceContactEmail:'',
              statusList:[],
              overdueDays:null,
              issuanceDateRange:[],
              startOverdueDays:null,
              endOverdueDays:null,
              invoiceNumber:'',
              settlementDateRange:[],
              commentDate:[]
          },
          chooseable: false,
          data: [],
          downloadDialogMode: '', // download | export
          pagination: {
              pageNum: 1,
              pageSize: 10,
              total: 0
          },
          loading: false,
          btnLoading: false,
          addVisible: false,
          uploadVisible: false,
          messageBoardVisible: false,
          fileDetailVisbile: false,
          rowData: {},
          initData: {}, //编辑/新增传递参数
          fileDownloading: false,
          curUserName: '',
          downloadAble: false,
          
          multiChoose: {
              /* 是否可多选的状态在上层 */
              /* 已选中的数组在上层 */
              mode: '' // download | email
          },
          isIE: false,
          roleItu: false,
          roleItuGeneral: 0,
          batchEntityName:'',
          invoiceStatusOpt:[],
          fapiaoDetailVisible:false,
          fileSelectionVisible:false,
          fileSelectionType:"",
          fapiaoBatchVisible:false,
      }
  },
  watch: {
    searchForm:{
        deep:true,
        handler(v){
             
            const clearActive = v.entityNameEn.length>0||(v.issuanceDateRange.length>1&&v.issuanceDateRange[0].length>0)||v.entityNameCn.length>0||v.invoiceContactEmail.length>0||!!v.startOverdueDays||!!v.endOverdueDays||v.statusList.length>0||v.feeAmountRange.length>0||v.totalAmountRange.length>0||v.invoiceNumber.length>0||(v.settlementDateRange.length>1&&v.settlementDateRange[0].length>0)||(this.searchForm.commentDate && !!this.searchForm.commentDate[0])
            this.$emit("update:clearFilterActive",clearActive)
        }
    }
  },
  async mounted() {
    this.getInvoiceStatusOpt()
    await this.getTableList()
    await this.queryLimits()
  },
  methods: {
    async previewPdf(row){
      const res = await API.clientAdmin.previewInvoice({
            invoiceId:row.id
        })
        var file = new Blob([res], { type: 'application/pdf;charset=utf-8' })
        const pdfBlob = window.URL.createObjectURL(file)
        window.open(pdfBlob)
    },
    downloadConfirm(){
        if(this.isNOT_LLP){
            this.tooglebatchDownLoad('download')
        }else{
            this.toggleFileSelectionVisible()
        }
    },
    cancelBatchExport() {
        this.fileSelectionVisible = false;
        this.cancelChoose();
    },
    saveSelectionType(type) {
        this.fileSelectionType = type;
        console.log(this.fileSelectionType)
        this.fileSelectionVisible = false;
        if(type==='bill') {
            this.tooglebatchDownLoad('download')
        }else{
            this.fapiaoBatchVisible = true;
        }

    },
    // 查询当前站点downloadable
    async queryLimits() {
        const { code, data } = await API.clientUser.getSiteConfig({ param: this.getSite.siteId })
        if (code == '1') {
            this.downloadAble = !!data.downloadable
        } else {
            this.$message.error(this.$t(code))
        }
        // 当前文件uploadby
        let userType = this.getUser.userType
        if (userType == '1') {
            this.curUserName = this.getUser.userName
        } else {
            this.curUserName = this.getUser.userAccount
        }
    },
    calcDisableDownload(row) {
        return !this.hasPermission('download') ||
                this.getUser.userType === '2' &&
                !this.downloadAble &&
                row.uploadBy &&
                row.uploadBy.indexOf('@') !== -1
    },
    getInvoiceStatusOpt() {
        API.common.getDict({dictName: 'invoice_status'}).then(res => {
          if (res.code !== '1') return;
          this.invoiceStatusOpt = res.data
        })
      },
    downloadFeeNote(row){
        const fileInfo = {
            id: row.id,
            fileId: row.fileList[0].fileId,
            siteEntityId: row.id,
            siteId: this.getSite.siteId,
            source: 'invoices',
            fileName: row.fileList[0].name 
        }
        downloadSingleFile(fileInfo)
    },
    renderStatusIcon(status){
        if (status === 'FULLY PAID') {
            return `status_FULLY PAID`
        } else return `status_CANCELLED`
    },
    renderStatusColor(status){
        const statusColorOptions = {
            'FULLY PAID':'#269924',
            'NOT PAID':'#ed2124',
            'PARTIALLY PAID':'#ecb113',
            'CANCELLED':'#989898',
        }
        return statusColorOptions[status]
    },
    overdueDaysStyle(status) {
        const statusColorOptions = {
            'FULLY PAID':'#269924',
            'NOT PAID':'#ed2124',
            'PARTIALLY PAID':'#ecb113',
            'CANCELLED':'#989898',
        }
        return {
            backgroundColor: `${statusColorOptions[status]}18`,
            color: statusColorOptions[status],
        }
    },
    clearOverdueRange() {
        this.searchForm.startOverdueDays = null
        this.searchForm.endOverdueDays = null
    },
    filterOverdueDays() {
        if((!this.searchForm.startOverdueDays&&this.searchForm.endOverdueDays)||(this.searchForm.startOverdueDays&&!this.searchForm.endOverdueDays)) {
            this.$message.error(this.$t('admin.enterTip',{name:this.$t('admin.overdueDaysRange')}))
            this.clearOverdueRange()
            return
        }else if(Number(this.searchForm.startOverdueDays) > Number(this.searchForm.endOverdueDays)){
            this.$message.error(this.$t('admin.overdueDaysRangeError'))
            this.clearOverdueRange()
            return
        }
        this.hidePopperSearch()
    },
      hidePopperSearch() {
          this.pagination = {
              pageNum: 1,
              pageSize: 10,
              total: 0
          }
          this.getTableList()
      },
      exportList(type) {
        const api = type ==='invoice'?API.clientAdmin.exportInvoicesList:API.clientAdmin.exportFapiaoList;
        let params = this.getSearchParams()
          const _loading = loading()
          _loading.download()
          api(params).then((res) => {
                  if (/application\/json/.test(res.data.type)) {
                      let reader = new FileReader()
                      reader.onload = (e) => {
                          if (e.target.readyState === 2) {
                              let resJson = {}
                              resJson = JSON.parse(e.target.result)
                              this.$message.error({ duration: 5000, message: this.$t(resJson.code) })
                          }
                      }
                      reader.readAsText(res.data)
                  }
                  if (/application\/octet-stream/.test(res.data.type)) {
                      let blob = new Blob([res.data])
                      const filename = decodeURI(res.headers['content-disposition'].replace('attachment; filename=', ''))
                      if (isIE()) {
                          navigator.msSaveBlob(blob, filename)
                      } else {
                          let url = window.URL.createObjectURL(blob)
                          let link = document.createElement('a')
                          link.style.display = 'none'
                          link.href = url
                          link.setAttribute('download', filename)
                          document.body.appendChild(link)
                          link.click()
                      }
                  }
              })
              .catch((e) => {})
              .finally(() => {
                  _loading.close()
              })
      },
      toogleMultiSelect(mode) {
            this.multiChoose = {
              mode: mode
          }
          this.chooseable = true
      },
      cancelChoose() {
          this.$refs.exchangeTable.clearSelection()
          this.chooseable = false
      },
      
      
      // 页码
      onCurrentPageChange(val) {
          this.pagination.pageNum = val
          this.getTableList()
      },
      onSizeChange(val) {
          this.pagination.pageNum = 1
          this.pagination.pageSize = val
          this.getTableList()
      },
      async clearAll() {
            this.searchForm = {
                entityNameEn:'',
                entityNameCn:'',
                feeAmountRange:[],
                totalAmountRange:[],
                invoiceContactEmail:'',
                statusList:[],
                overdueDays:null,
                issuanceDateRange:[],
                startOverdueDays:null,
                endOverdueDays:null,
                invoiceNumber:'',
                settlementDateRange:[],
                commentDate:[]
            }
            await this.getTableList()
      },
      getSearchParams(){
        let params = {
              siteId: this.getSite.siteId,
              ...this.pagination,
              ...this.searchForm,
              startIssuanceDate: this.searchForm.issuanceDateRange && this.searchForm.issuanceDateRange[1] ? dateFormat(new Date(this.searchForm.issuanceDateRange[0]), 'yyyy-MM-dd') : null,
              endIssuanceDate: this.searchForm.issuanceDateRange && this.searchForm.issuanceDateRange[1] ? dateFormat(new Date(this.searchForm.issuanceDateRange[1]), 'yyyy-MM-dd') : null,
              minFeeAmount:this.searchForm.feeAmountRange && this.searchForm.feeAmountRange?this.searchForm.feeAmountRange[0]:null,
              maxFeeAmount:this.searchForm.feeAmountRange && this.searchForm.feeAmountRange?this.searchForm.feeAmountRange[1]:null,
              minTotalAmount:this.searchForm.totalAmountRange && this.searchForm.totalAmountRange?this.searchForm.totalAmountRange[0]:null,
              maxTotalAmount:this.searchForm.totalAmountRange && this.searchForm.totalAmountRange?this.searchForm.totalAmountRange[1]:null,
              startSettlementDate: this.searchForm.settlementDateRange && this.searchForm.settlementDateRange[1] ? dateFormat(new Date(this.searchForm.settlementDateRange[0]), 'yyyy-MM-dd') : null,
              endSettlementDate: this.searchForm.settlementDateRange && this.searchForm.settlementDateRange[1] ? dateFormat(new Date(this.searchForm.settlementDateRange[1]), 'yyyy-MM-dd') : null,
              startCommentDate: this.searchForm.commentDate && this.searchForm.commentDate[0] ? dateFormat(new Date(this.searchForm.commentDate[0]), 'yyyy-MM-dd') : null,
              endCommentDate: this.searchForm.commentDate && this.searchForm.commentDate[1] ? dateFormat(new Date(this.searchForm.commentDate[1]), 'yyyy-MM-dd') : null,
          }
          return params
      },
      // 获取表格信息
      async getTableList() {
        let params = this.getSearchParams()
          this.loading = true
          const { code, data } = await API.clientAdmin.queryInvoicesInfo(params)
          if (code === '1') {
              this.data = data.records|| []; 
              this.pagination.total = data.total
              // 回显已选中的
              this.handleEchoData('exchangeTable', this.data)
          } else {
              this.$message.error(this.$t(code))
          }
          this.loading = false
      },
      // 新增
      toggleAddVisible() {
          this.initData = {}
          this.addVisible = !this.addVisible
      },
      // 编辑
      onEdit(row) {
          this.initData = row
          this.addVisible = !this.addVisible
      },
      // 新增---保存
      async saveContractItem(form) {
        form.siteId = this.getSite.siteId
        const { code, data } = await API.clientAdmin.addContractInfo(form)
        try {
            if (code == '1') {
                this.$message.success(this.$t('msg_success'))
            } else {
                this.$message.error(this.$t(code))
            }
        } catch (e) {
            this.$message.error(e)
        }
          this.pagination.pageNum = 1
          await this.getTableList()
          this.addVisible = !this.addVisible
      },
      // 删除
      onDelete(row) {
          this.$confirm(this.$t('msg_delete_sure'), this.$t('COMMON_TIP'), {
              confirmButtonText: this.$t('btn_confirm'),
              cancelButtonText: this.$t('btn_cancel'),
              type: 'warning',
              cancelButtonClass: 'cancel-btn',
              confirmButtonClass: 'wl-green'
          })
              .then(() => {
                  API.clientAdmin.deleteContractInfo({id:row.id}).then((res) => {
                      if (res.code == '1') {
                          this.$message.success(this.$t('msg_success'))
                      } else {
                          this.$message.error(this.$t(code))
                      }
                      this.getTableList()
                  })
              })
              .catch(() => {
                  this.$message({
                      type: 'info',
                      message: this.$t('CANCLE_OPERATION')
                  })
              })
      },
      // upload
      toogleUploadVisible(row) {
          if (!this.hasPermission('upload')) {
              return
          }
          this.rowData = row
          this.uploadVisible = !this.uploadVisible
      },
      closeUploadVisble() {
          this.getTableList()
          this.uploadVisible = !this.uploadVisible
      },
      async uploadSuccess() {
          await this.getTableList()
          this.rowData = this.data.filter((item) => item.id === this.rowData.id)[0]
      },
      // 留言
      toogleMessageBoardVisible(row) {
          this.messageBoardVisible = !this.messageBoardVisible
          this.rowData = row
      },

      updateMultipleSelection(row) {
          this.hasSelectedList = row
      },
      downloadFileDetail(v) {
          if (v.length > 0) {
              const list = []
              v.forEach((i, n) => {
                  list.push({
                      id: i.id,
                      fileId: i.fileId,
                      siteEntityId: i.id,
                      siteId: this.getSite.siteId,
                      source: 'invoices',
                      fileName: i.name
                  })
              })
              if (list.length === 0) {
                  this.$message.error(this.$t('FILE_LIST_EMPTY_ALERT'))
                  return
              }
              if (list.length === 1) {
                  this.downloadFileListSingle(list[0])
              }

              this.$refs.exchangeTable.clearSelection()
              this.chooseable = false
          }
      },
      async downloadFileListSingle({ siteId, fileId, source, siteEntityId, fileName }) {
          try {
              this.fileDownloading = true
            const fileInfo = {
                id: siteEntityId,
                fileId,
                siteEntityId,
                siteId,
                source,
                fileName
            }
            downloadSingleFile(fileInfo)
          } catch (e) {
          } finally {
              this.fileDownloading = false
              this.$refs.FileConfirmModal.visible = false
              this.$refs.exchangeTable.clearSelection()
              this.chooseable = false
          }
      },
      toggleFileSelectionVisible() {
        this.fileSelectionVisible = true;
      },
      // 批量下载页面
      tooglebatchDownLoad(mode) {
          this.downloadDialogMode = mode
          if (this.hasSelectedList.length > 0) {
              let list = []
              this.hasSelectedList.forEach((item) => {
                  if (item.fileList && item.fileList.length > 0) {
                      item.fileList.forEach((f) => {
                          if (
                              !(
                                  this.getUser.userType === '2' &&
                                  !this.downloadAble &&
                                  f.uploadBy &&
                                  f.uploadBy.indexOf('@') !== -1 &&
                                  f.uploadBy.indexOf(this.curUserName) == -1
                              )
                          ) {
                              list.push({
                                  rowId: item.id,
                                  fileName: f.name,
                                  fileId: f.fileId,
                                  bindId: item.id,
                                  siteId: this.getSite.siteId,
                                  source:'invoices'
                              })
                          }
                      })
                  }
              })
              if (list.length === 0) {
                  this.$message.error(this.$t('FILE_LIST_EMPTY_ALERT'))
                  return
              } else if (list.length === 1) {
                  if (mode == 'download') {
                    
                      this.downloadFileListSingle({
                          id:list[0].rowId,
                          siteId: this.getSite.siteId,
                          fileId: list[0].fileId,
                          source: 'invoices',
                          siteEntityId: list[0].rowId,
                          fileName: list[0].fileName 
                      })
                  } else if (mode == 'export') {
                      this.$refs.FileConfirmModal.visible = true
                  }
              } else {
                  this.$refs.FileConfirmModal.visible = true
              }
          }
      },
      // 批量下载
      downloadMultipleFiles(rows,sourceType) {
        const source = sourceType?sourceType:'invoices'
          if (this.downloadDialogMode == 'download' || source === 'fapiao') {
              if (rows.length === 1) {
                  const { rowId, name, fileId } = rows[0]
                  this.downloadFileListSingle({ siteId: this.getSite.siteId, fileId: fileId, source, siteEntityId: rowId })
              } else {
                  let size = 0
                  const list = rows.map((row) => {
                      size += parseInt(row.size || 0)
                      return {
                          siteEntityId: row.rowId,
                          siteId: this.getSite.siteId,
                          fileId: row.fileId,
                          source
                      }
                  })
                  if (size > windowConfig.download.size) {
                      this.$confirm(
                          this.$t('largeSizeFileAlertContent', { size: formatFileSize(windowConfig.download.size) }),
                          this.$t('largeSizeFileAlertTitle'),
                          {
                            distinguishCancelAndClose: true,
                            showConfirmButton:false,
                            cancelButtonText: this.$t('btn_ok'),
                            cancelButtonClass: 'wl-green',
                          }
                      ).then(() => {
                          this.downloadBatchList({ list },size)
                      })
                  } else {
                      this.downloadBatchList({ list },size)
                  }
              }
          } 
      },
      //批量下载
      async downloadBatchList(params,size) {
          try {
            const fileIdList = params.list.map((item) => item.fileId).join(',')
            const reqParams = {
                siteId: this.getSite.siteId,
                fileIdList,
                source:params.list[0].source
            }
            this.$refs.FileConfirmModal.visible = false
            downloadBatchFiles('/file/free/downloadAdminBatchFilesAsZip', reqParams,size)
          } catch (e) {
              this.$message.error(e.message)
          } finally {
              this.fileDownloading = false
              this.$refs.FileConfirmModal.visible = false
              this.$refs.exchangeTable.clearSelection()
              this.chooseable = false
          }
      },
    //   发票详情页切换
    async toggleFaPiaoDetail(row){
        this.rowData = row;
        this.fapiaoDetailVisible = !this.fapiaoDetailVisible;
    }
  }
}
</script>

<style scoped>
::v-deep .exchange-table .el-table__body-wrapper {
  height: calc(100% - 44px) !important;
}
.overdue-days{
    color:#ffffff;
    padding: 3px 15px;
    display: inline-block;
    width: 90%;
    text-align: center;
    border-radius: 4px;
}
.admin-container {
  height: 100%;
  background: #eff1f5;
}
.table-header-blue-icon {
  color: #3879eb;
  font-size: 15px;
  margin-left: 5px;
  cursor: pointer;
      
}
.table-cell {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
}
.table-td-comment {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.fapiao-col{
    text-align: center;
}

.fapiao-col .fee-note{
    padding-left: 10px;
    padding-right: 10px;
}

.admin-content-container {
  background: #fff;
  height: 100%;
}

.clear-filter {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  font-size: 12PX;
}

.clear-filter img {
  margin-right: 5px;
}

.search-row,
.bar-row {
  height: 35PX;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.search-row .el-button,
.bar-row .el-button {
  height: 30PX;
  border-radius: 5px;
}
.left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.search-item {
  margin-right: 20px;
  width: 260px;
}
.search-item .el-date-editor.el-input {
  width: 260px;
}

.wl-search-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.table-container-wrapper {
  margin-top: 5PX;
  height: calc(100% - 93PX);
  position: relative;
}
.table-container-wrapper.show-table-bottom-operate {
  height: calc(100% - 93PX - 59px);
}
.wl-icon-messageBoard {
  font-size: 18px;
  color: #3879eb;
  cursor: pointer;
}

.wl-icon-messageBoardNull {
  color: #c0c4cc;
  font-size: 18px;
  cursor: pointer;
}

.upload-forbid {
  cursor: not-allowed;
}

.fee-note {
  margin-right: 10px;
  width: 100%;
  cursor: pointer;
  user-select: none;
  color: blue;
  text-decoration: underline;
}

.wl-icon-no-delete {
  color: #c0c4cc;
  font-size: 18px;
  cursor: pointer;
}

.wl-icon-no-edit {
  color: #c0c4cc;
  font-size: 18px;
  cursor: pointer;
}

.wl-icon-record {
  color: #1aa0a0;
  font-size: 18px;
  cursor: pointer;
}
.input-amount-container{
    width: 200px;
}
.input-with-select {
  width: 120px;
  margin: 0 10px;
}

.wl-overflow-tooltip {
  overflow: hidden;
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.template-uploader {
  margin-left: 10px;
}

.wl-green {
  height: 32px;
}
.mgr10 {
  margin-right: 10PX;
}
.footer-btn {
  height: 50px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
::v-deep .el-pagination .el-select .el-input {
  width: 150px;
}
.header-with-popup {
  display: flex;
  flex-direction: row;
  justify-content: left;
}


.margin-bottom-10 {
  margin-bottom: 10PX;
}
.guide-btn {
  float: right;
  color: #3879eb;
}

.invoice-tip {
    color:#606266;
    text-align: right;
}

.file-name-cell .file-name {
  display: inline-block;
  margin-right: 10px;
}
.file-name-cell .can-download {
  cursor: pointer;
  user-select: none;
  color: rgb(120, 120, 195);
}
.file-name-cell .can-download:hover {
  color: rgb(120, 120, 195);
  text-decoration: underline;
}
.pointer {
  cursor: pointer;
  color: #3879eb;
}
.icon-preview {
  margin-right: 10px;
}
.el-icon-view,
.el-icon-download {
  color: #3879eb;
  font-weight: bold;
}
</style>

